import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsRequiredAddressField } from '~/src/redux/lead/lead.slice';
import { COLORS } from '~/src/styles/tokens/colors';
import { SvgError } from '~/src/components/svg-components/error';
import * as Styled from './address-required-plank.styles';

export const AddressRequiredPlank: FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setIsRequiredAddressField(true));

        return () => {
            dispatch(setIsRequiredAddressField(false));
        };
    }, []);

    return (
        <Styled.AddressRequiredPlankContainer>
            <Styled.Content>
                <div>
                    <SvgError fill={COLORS.accentWarning} />
                </div>
                <Styled.TextPlank>
                    Для выбранных продуктов необходимо ввести <Styled.Address>адрес</Styled.Address> предоставления
                    услуги
                </Styled.TextPlank>
            </Styled.Content>
        </Styled.AddressRequiredPlankContainer>
    );
};
